import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrlLanguagePickerComponent} from './components/prl-language-picker/prl-language-picker.component';
import {PrlLabelComponent} from './components/prl-label/prl-label.component';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from '../../shared/shared.module';


@NgModule({
    declarations: [
        PrlLanguagePickerComponent,
        PrlLabelComponent
    ],
    exports: [
        PrlLanguagePickerComponent,
        PrlLabelComponent
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        SharedModule
    ]
})
export class PrlLanguageModule {
}
